import Vue from 'vue'

import './assets/favicons/favicons'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueSVGIcon from 'vue-svgicon'
import '@/compiled-icons'
import moment from 'moment'
import VueQuill from 'vue-quill'
import PrettyCheckbox from 'pretty-checkbox-vue'

moment.locale('de')

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).calendar()
  }
})

Vue.filter('defaultDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YY')
  }
})

Vue.filter('defaultDay', function (value) {
  if (value) {
    return moment(String(value)).format('dddd')
  }
})

Vue.filter('defaultTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm') + ' Uhr'
  }
})

Vue.use(VueSVGIcon)

Vue.use(Vuex)
Vue.use(VueQuill)
Vue.use(PrettyCheckbox)

export const store = new Vuex.Store({
  state: {
    safelyStoredNumber: 0
  },
  editArea: {
    area: null
  },
  mutations: {
    increment (state) {
      state.safelyStoredNumber++
    },
    setEditArea (state) {
      // editArea.area = state
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js